import React,{useEffect,useState,useMemo} from "react";
import {Table,Spin} from "antd";
import axios from "axios";
import {clientColumns} from "../columns/clientColumns";
import {LedgerResponsiveWrapper,denseTableProps,API_BASE,getArn,rowMatchesSearch} from "../LedgerResponsive";
import ReportOptionsModal from "../modals/ReportOptionsModal";

export default function ClientTable({searchQuery,onOpenModal,onDrillClient}){
 const [clients,setClients]=useState([]),[loading,setLoading]=useState(false),[reportClient,setReportClient]=useState(null);
 useEffect(()=>{setLoading(true);axios.get(`${API_BASE}/get_clients.php?arn_no=${getArn()}`)
 .then(r=>setClients(r.data.clients||[])).catch(()=>setClients([])).finally(()=>setLoading(false));},[]);
 const filtered=useMemo(()=>clients.filter(c=>rowMatchesSearch(c,searchQuery)),[clients,searchQuery]);
 return <><LedgerResponsiveWrapper>{loading?<Spin/>:<Table
 columns={clientColumns(onOpenModal,setReportClient)} dataSource={filtered} rowKey="pan" {...denseTableProps}
 onRow={(record)=>({onClick:(e)=>{if(e.target.closest("button,a,[role='button']"))return;onDrillClient?.(record);},style:{cursor:"pointer"}})}/>}</LedgerResponsiveWrapper>
 <ReportOptionsModal open={!!reportClient} client={reportClient} onClose={()=>setReportClient(null)}/></>;
}
